import Vue from "vue";

export const filterExchangeRate = (value: string | number): string => {
  if (!value) return "0.0000";
  if (typeof value === "string") {
    value = parseFloat(value.replace(" ", "").replace(",", "."));
  }
  return (Math.round(value * 10000) / 10000).toFixed(4);
};

Vue.filter("formatExchangeRate", filterExchangeRate);
